/*
 * @Author: DYM
 * @Date: 2020-06-18 10:45:09
 * @LastEditors: DYM
 * @LastEditTime: 2020-06-18 11:43:31
 * @Description: 职位管理路由
 */

/* 路由配置说明
name: 'router-name' // 设定路由的名字，要求唯一性
webpackChunkName: "sysMenu" // 设置打包模块，要求名称与name一致，唯一性
meta: {
  navtabTitle: '' // 设置该路由navtabTitle为stringf或者function
  isCache: true  // 设置页面需要缓存，再次打开页面不刷新数据，默认false，设为true缓存页面
  ignoreDiff: [] // 设置判断页面是否相同需忽略的参数，判断处理时默认忽略isRefresh参数，因此isRefresh不需在此设置
  isSecondary: true  // 页面为父页面的一个小页面，不需要展示在tab上作为一个tab页面展示，设置为true，默认false
  isIframe: false // 是否为iframe页面
}
*/

const positionRoutes = {
  path: 'position',
  name: 'position',
  component: () => import(/* webpackChunkName: "position" */ '@/features/system/position/list.vue'),
  meta: {
    navtabTitle: '职位管理',
    isCache: true,
    ignoreDiff: [],
    isSecondary: false
  }
};

export default positionRoutes;
